import { FC } from "react";

interface MapLocationDotIconProps {
  width: number;
  height: number;
  colorOne?: string;
  colorTwo?: string;
}

const MapLocationDotIcon: FC<MapLocationDotIconProps> = ({
  width,
  height,
  colorOne,
  colorTwo,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52 5C77.9574 5 99 26.0426 99 52C99 77.9574 77.9574 99 52 99C26.0426 99 5 77.9574 5 52C5 26.0426 26.0426 5 52 5Z"
        fill="white"
        stroke={colorOne ?? "#78B9FF"}
        strokeWidth="10"
      />
      <path
        d="M52 14C72.9868 14 90 31.0132 90 52C90 72.9868 72.9868 90 52 90C31.0132 90 14 72.9868 14 52C14 31.0132 31.0132 14 52 14Z"
        fill={colorTwo ?? "#127EF1"}
        stroke="white"
        strokeWidth="8"
      />
    </svg>
  );
};

export default MapLocationDotIcon;
